import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import UploadWizard from './UploadWizard';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}/:ecoleid`} component={UploadWizard} />
    </Switch>
  </>
);

export default Routes;
